import axios from 'axios'
import config from '../config'
import authenticationStore from '../stores/authenticationStore'

const { apiUrl } = config

export const CommentFileRequest = {
  getCommandList: params =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/common-files`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      params: params,
    }),
  getCommandsByUser: data =>
    axios({
      method: 'put',
      url: `${apiUrl}/api/v1/common-files/update-regis-number/files`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      data: data,
    }),
}
